"use client";

import { useEffect } from "react";
import { useShopifyCookies } from "@shopify/hydrogen-react";

/**
 * Component to initialize Shopify Analytics cookies
 * This component handles the useShopifyCookies hook which must be used in a React component
 */
export function ShopifyAnalyticsScript() {
  // Enable Shopify attribution tracking via cookies
  useShopifyCookies({
    hasUserConsent: true,
    domain: process.env.NEXT_PUBLIC_SHOPIFY_STORE_ANALYTICS_DOMAIN,
  });

  useEffect(() => {
    console.log("Shopify Analytics cookies initialized");
  }, []);

  return null; // This component doesn't render anything
}
